import { Checkbox, Form } from 'antd';
import classNames from 'classnames';
import { useContext } from 'react';

import {
  AvailableOn as AvailableOnEnum,
  EARLY_CHECKIN,
  LATE_CHECKOUT,
  getDisableLimitation,
} from 'app/components/commons/Experience/Availability/utils';
import { FormLineLayout } from 'app/components/commons/Form/FormLineLayout/FormLineLayout';
import { ViewEditModeContext } from 'app/context/ViewEditModeContext/ViewEditModeContext';

const RULES = [{ required: true, message: 'Required' }];
const DEFAULT_CATEGORY_ID = 0;

const AVAILABLE_ON = [
  {
    label: 'Day of check-in',
    value: AvailableOnEnum.CHECK_IN,
  },
  { label: 'Mid-stay', value: AvailableOnEnum.MID_STAY },
  { label: 'Day of check-out', value: AvailableOnEnum.CHECK_OUT },
] as const satisfies readonly { value: AvailableOnEnum; label: string }[];

export const AvailableOn = () => {
  const { isViewMode } = useContext(ViewEditModeContext);
  const form = Form.useFormInstance();
  const categoryId = Form.useWatch(['categoryId'], form);

  const availableDayLimits = AVAILABLE_ON.map((item) => ({
    ...item,
    disabled: getDisableLimitation(DEFAULT_CATEGORY_ID, item.value),
  }));

  const isCheckInOrCheckOutExp =
    categoryId === EARLY_CHECKIN || categoryId === LATE_CHECKOUT;

  return (
    <FormLineLayout label="Available on" isRequired>
      <Form.Item name={['availableDayLimits']} rules={RULES}>
        <Checkbox.Group disabled={isViewMode}>
          {availableDayLimits.map((limit) => (
            <Checkbox
              key={limit.value}
              value={limit.value}
              name={limit.value}
              disabled={limit.disabled || isCheckInOrCheckOutExp}
              className={classNames([
                {
                  checkedAndDisabled: !limit.disabled && isCheckInOrCheckOutExp,
                },
              ])}
            >
              {limit.label}
            </Checkbox>
          ))}
        </Checkbox.Group>
      </Form.Item>
    </FormLineLayout>
  );
};
